import React, { useId } from 'react';
import {
  Accordion as ApricotAccordion,
  AccordionItem,
  AccordionTrigger,
  AccordionPanel,
  Icon,
} from '@cb/apricot-react';
import './AccordionSummary.scss';
import { SentenceLoader } from '../../ui/sentenceLoader/SentenceLoader';

interface AccordionSummaryProps {
  title: React.ReactNode;
  startSummaryText?: React.ReactNode;
  endSummaryText?: React.ReactNode;
  showSummary?: boolean;
  summaryLoading?: boolean;
  panelContent?: React.ReactNode;
  className?: string;
}

function AccordionSummary({
  title,
  startSummaryText,
  endSummaryText,
  showSummary,
  summaryLoading = false,
  panelContent,
  className = '',
}: AccordionSummaryProps) {
  const titleId = useId();
  const shouldRenderSummary = summaryLoading || (showSummary ?? Boolean(startSummaryText || endSummaryText));

  return (
    <div className={`tdtk-summary-accordion cb-white-bg ${className}`.trim()} role='region' aria-labelledby={titleId}>
      <ApricotAccordion className='tdtk-summary-accordion__container' single={false}>
        <AccordionItem open={true}>
          <div className='tdtk-summary-accordion__header-row'>
            <span id={titleId} className='tdtk-summary-accordion__title'>
              {title}
            </span>
            <AccordionTrigger
              className='tdtk-summary-accordion__trigger'
              aria-describedby={titleId}
              iconPosition='none'
              closedLabel={
                <span className='d-inline-flex align-items-center'>
                  <span>Show</span>
                  <Icon name='down' decorative className='cb-margin-left-4' />
                </span>
              }
              openLabel={
                <span className='d-inline-flex align-items-center'>
                  <span>Hide</span>
                  <Icon name='up' decorative className='cb-margin-left-4' />
                </span>
              }
            />
          </div>
          <AccordionPanel className='tdtk-summary-accordion__panel'>
            {panelContent}
            {shouldRenderSummary && (
              <div className='tdtk-summary-accordion__sentences'>
                {summaryLoading ? (
                  <>
                    <div className='tdtk-summary-accordion__skeleton-line'>
                      <SentenceLoader ariaId={`tdtk-${titleId}-band-loader-exam-start-time`} />
                      <SentenceLoader ariaId={`tdtk-${titleId}-band-loader-exam-end-time`} />
                    </div>
                  </>
                ) : (
                  <>
                    {startSummaryText && <p className='tdtk-summary-accordion__summary'>{startSummaryText}</p>}
                    {endSummaryText && <p className='tdtk-summary-accordion__summary'>{endSummaryText}</p>}
                  </>
                )}
              </div>
            )}
          </AccordionPanel>
        </AccordionItem>
      </ApricotAccordion>
    </div>
  );
}

export default AccordionSummary;
